import {
    GET_ALL_RAFFLES,
    GET_RAFFLE,
    ADD_RAFFLE,
    EDIT_RAFFLE,
    DELETE_RAFFLE,
    CLEAR_RAFFLE
} from '../actions/RaffleActions'
import { persistReducer } from 'redux-persist';
import storage from 'localforage';

const persistConfig = {
    key: 'raffles',
    storage,
};

const initialState = {
    data: [],
    allRaffles: [],
    raffle: '',
    totalRaffles: 0,
    totalPages: 0,
    currentPage: 1,

    latestUpdate: '',
    loading: false,
    error: '',
}

const RaffleReducer = function (state = initialState, action) {
    switch (action.type) {
        case ADD_RAFFLE: {
            let tempArray = Object.assign({}, state.allRaffles)
            tempArray.rows = [action.payload, ...state.allRaffles.rows]
            return {
                ...state,
                allRaffles: tempArray,
            }
        }
        case EDIT_RAFFLE: {
            let tempArray = Object.assign({}, state.allRaffles)
            let target = tempArray.rows.findIndex(item => {return item.id == action.payload.id})
            tempArray.rows[target] = action.payload            
            return {
                ...state,
                allRaffles: tempArray,
            }
        }
        case DELETE_RAFFLE: {
            let tempArray = Object.assign({}, state.allRaffles)
            let newArray = tempArray.rows.filter(item => {return item._id !== action.payload})
            tempArray.rows = newArray            
            return {
                ...state,
                allRaffles: tempArray,
            }
        }
        case GET_ALL_RAFFLES: {
            return {
                ...state,
                data: action.payload.raffles.raffles,
                currentPage: action.payload.raffles.currentPage,
                totalRaffles: action.payload.raffles.totalElements,
                totalPages: action.payload.raffles.totalPages,
            }
        }
        case GET_RAFFLE: {
            return {
                ...state,
                raffle: action.payload.raffle,
            }
        }
        case CLEAR_RAFFLE: {
            return {
                ...state,
                raffle: '',
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default persistReducer(persistConfig, RaffleReducer);
